import { useMemo } from "react";

const PS_UALARMS = {
    "UA01": "ALARMA 1 DE USUARIO",
    "UA02": "ALARMA 2 DE USUARIO",
    "UA03": "ALARMA 3 DE USUARIO",
    "UA04": "ALARMA 4 DE USUARIO"
}


const PS_ALARMS = {
    "A01": "FALLO DE TENSIÓN DE LÍNEA",
    "A02": "PÉRDIDA FASE",
    "A03": "ERROR DE SECUENCIA DE FASES",
    "A04": "FREC. FUERA DE LÍMITES",
    "A05": "FALLO DE TENSIÓN AUX.",
    "A06": "CORRIENTE ASIMÉTRICA",
    "A07": "PROT. SOBRECORRIENTE",
    "A08": "ROTOR BLOQUEADO",
    "A09": "CARGA DEMASIADO BAJA",
    "A10": "ARRANQ. DEMASIADO LARGO",
    "A11": "AVERÍA DE RELÉ DE BYPASS",
    "A12": "PREAL. TÉRMICA MOT.",
    "A13": "PREAL. TÉRMICA ARR.",
    "A14": "PROT. TÉRMICA MOTOR",
    "A15": "PROT. TÉRMICA ARR.",
    "A16": "FASE L1-T1 EN CORTOCIRCUITO",
    "A17": "CORTOCIRCUITO EN FASE L3-T3",
    "A18": "AVERÍA DE SENSOR TEMP.",
    "A19": "TENSIÓN DE LÍNEA BAJA",
    "A20": "TENSIÓN DE LÍNEA ALTA",
    "A21": "CORRIENTE MOT. BAJA",
    "A22": "SOLIC. MANTENIMIENTO",
    "A23": "FALLO DE VENTILADORES",
    "A24": "VENTILADOR BLOQUEADO",
    "A25": "ERROR DE SISTEMA",
}

export const ALARMAS_PS = {
  ...PS_ALARMS,
  ...PS_UALARMS, 
}


// Función auxiliar para calcular el mensaje
export function getStatusMessage ({
  generador,
  controlType,
  bomba,
  bombaConectada,
  paradaEmergencia,
  alarmIndex,
  generadorApagado
}) {
  // console.log("DEBUG alarms:", bomba.alarms, "alarmIndex:", alarmIndex, "controlType:", controlType, "bombaConectada:", bombaConectada, "paradaEmergencia:", paradaEmergencia);
  // Si el generador está apagado → no mostrar ninguna alarma de la bomba
  // if (generadorApagado) return null;
  // console.log("DEBUG generadorApagado:", generadorApagado);
  // Generador apagado sin alertas
  
  if (
    (generador?.partida === 60 && generador?.detencion === 100) ||
    generador?.hf_status === 60
  ) {
    return null;
  }

  if (controlType === "PS") {
    if (!bombaConectada && generadorApagado) {
      return "SIN COMUNICACIÓN";
    }
    if (paradaEmergencia) {
      return "PARADA DE EMERGENCIA";
    }
    if ((Array.isArray(bomba.alarms) && bomba.alarms.length > 0) || bomba.Status === 13) {
      const alarms = Array.isArray(bomba.alarms) ? bomba.alarms : [];
      if (alarms.length === 0) return "Alerta";

      const code = alarms.length > 1 ? alarms[alarmIndex] : alarms[0];
      const desc = ALARMAS_PS[code] || "Descripción no disponible";
      return `${code} - ${desc}`;
    }
  }

  if (controlType === "VDF") {
    if (!bombaConectada) return "SIN COMUNICACIÓN";
    if (bomba.Fault !== 0) return bomba.Fault;
  }

  return null;
};


// hooks/useCenterStatus.js

export const MINPRESION = 3.5;

export function useCenterStatus(center, generador) {
  const modulos = Array.isArray(center?.modulos) ? center.modulos : [];

  if (!Array.isArray(center?.modulos)) {
    console.warn("⚠️ center.modulos no es array:", center?.modulos);
  }

  // Si el generador está apagado, solo ignoramos las bombas sin comunicación
  const generadorApagado =
    (generador?.partida === 60 && generador?.detencion === 100) ||
    generador?.hf_status === 60;

  // 1️⃣ Extraer todas las bombas
  const bombas = useMemo(() => {
    const arr = [];
    modulos.forEach((m) =>
      (m?.cans || []).forEach((c) =>
        (c?.bombas || []).forEach((b) => arr.push(b))
      )
    );
    return arr;
  }, [modulos]);

  // 2️⃣ Detectar fallas básicas reales
  const sinComReal = bombas.filter((b) => !b.Device_Modbus_Status).length;

  const fallaSensor = bombas.filter(
    (b) => b.O2 === null || !b.O2_Modbus_Status
  ).length;

  const enFalla = bombas.filter(
    (b) =>
      Boolean(Number(b.InStop)) ||
      (Array.isArray(b.alarms) && b.alarms.length > 0)
  ).length;

  // Ignorar solo sin comunicación cuando el generador está apagado
  const sinCom = generadorApagado ? 0 : sinComReal;

  // 3️⃣ Detectar baja presión
  const hasLowPressure = useMemo(() => {
    if (generadorApagado) return false;

    return (
      Array.isArray(modulos) &&
      modulos.some(({ cans = [] }) =>
        cans.some(
          ({ presion, bombas = [] }) =>
            presion !== null &&
            presion < MINPRESION &&
            bombas.some((bomba) => Boolean(bomba?.aviot_status))
        )
      )
    );
  }, [modulos, generadorApagado]);

  // 4️⃣ Cálculo total
  const total = bombas.length;
  const activos = total - (sinCom + fallaSensor + enFalla);

  // 5️⃣ Determinar estado visual
  let estado = "ok";
  let color = "#16a34a"; // verde

  if (enFalla > 0 || sinCom > 0 || fallaSensor > 0 || hasLowPressure) {
    estado = "warning";
    color = "#ca8a04"; // amarillo
  }

  if (
    enFalla > 0 &&
    (sinCom > 0 || fallaSensor > 0 || hasLowPressure)
  ) {
    estado = "error";
    color = "#b91c1c"; // rojo
  }

  // 6️⃣ Retornar resultados
  return {
    bombas,
    total,
    sinCom,
    sinComReal,
    fallaSensor,
    enFalla,
    activos,
    hasLowPressure,
    generadorApagado,
    estado,
    color,
  };
}
